"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rounded = void 0;
var Rounded;
(function (Rounded) {
    Rounded["Normal"] = "u-rounded";
    Rounded["Large"] = "u-rounded-large";
    Rounded["Squared"] = "u-squared";
    Rounded["Ellipse"] = "u-ellipse";
    Rounded["Pill"] = "u-pill";
})(Rounded = exports.Rounded || (exports.Rounded = {}));
//# sourceMappingURL=Rounded.js.map